"use client"

import { PencilRuler } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PencilRulerIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PencilRulerIcon = component(Icon)({ as: PencilRuler })
